import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount, currency = 'CAD') {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

export function compressImage(file, quality = 0.7, maxWidth = 800) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const scale = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * scale;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                resolve(ctx.canvas.toDataURL('image/jpeg', quality));
            };
            img.onerror = (error) => {
                reject(error);
            };
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
}

// Resolve image candidate (string or object) into a usable URL string or null
export function resolveImageCandidate(candidate) {
  if (!candidate) return null;
  if (typeof candidate === 'string') {
    const s = String(candidate).trim();
    // Upgrade insecure http to https and handle protocol-relative URLs
    if (/^http:\/\//i.test(s)) return s.replace(/^http:\/\//i, 'https://');
    if (/^\/\//.test(s)) return `https:${s}`;
    return s;
  }
  if (typeof candidate === 'object') {
    return candidate.url || candidate.source || candidate.image_url || candidate.src || candidate.path || null;
  }
  return null;
}

// Resolve a product object into an image URL using the same fallback rules as ProductCard
export function resolveProductImage(p) {
  if (!p) return '/logo.png';
  // Prefer first aggregated image url if present
  let imgFromArray = null;
  if (Array.isArray(p.images) && p.images.length) {
    const first = p.images[0];
    imgFromArray = resolveImageCandidate(first) || (typeof first === 'string' ? first : null);
  }
  const candidates = [imgFromArray, p.image, p.image_url, p.main_image, p.thumbnail, p.photo];
  const chosen = candidates.find((c) => typeof c === 'string' && c && String(c).trim().length > 4);
  if (!chosen) return '/logo.png';
  // Ensure external http links are upgraded to https to avoid mixed-content warnings
  if (/^http:\/\//i.test(chosen)) return chosen.replace(/^http:\/\//i, 'https://');
  if (/^\/\//.test(chosen)) return `https:${chosen}`;
  if (/^(https?:)?\/\//i.test(chosen) || /^data:/i.test(chosen)) return chosen;
  const cleaned = String(chosen).replace(/^\/+/, '');
  const base = (import.meta.env.VITE_ASSETS_BASE || import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '');
  return `${base}/${cleaned}`;
}